import { c as _c } from "react/compiler-runtime";
import { Grid } from "@mui-wrapper";
import { Skeleton } from "@flat-ui";
import { CommonStyles } from "@styles/common-styles";

/**
 * Returns how many items should be shown per row based on the screen size.
 */
const defaultItemsPerRow = {
  xs: 1,
  sm: 2,
  md: 4,
  lg: 4,
  xl: 6,
  xxl: 6
};

/**
 * Returns the size that the columns should have to fit the provided elements.
 * The key is the amount of elements to fit
 * The value is the size in MUI columns (1-12).
 */
const colsSize = {
  one: 12,
  twoThird: 8,
  two: 6,
  three: 4,
  four: 3,
  six: 2,
  twelve: 1
};

/**
 * Calculates the size of the columns based on the amount of items to be shown for SM screens.
 * The key is the amount of shown items.
 * The value is the size of the columns.
 */
const colsSizeSm = {
  /* eslint-disable @typescript-eslint/naming-convention -- The namings use a provided value */
  1: colsSize.one,
  2: colsSize.two
  /* eslint-enable */
};

/**
 * Calculates the size of the columns based on the amount of items to be shown for MD screens.
 * The key is the amount of shown items.
 * The value is the size of the columns.
 */
const colsSizeMd = {
  /* eslint-disable @typescript-eslint/naming-convention -- The namings use a provided value */
  1: colsSize.one,
  2: colsSize.two,
  3: colsSize.three,
  4: colsSize.four
  /* eslint-enable */
};

/**
 * Calculates the size of the columns based on the amount of items to be shown for XL screens.
 * The key is the amount of shown items.
 * The value is the size of the columns.
 */
const colsSizeLg = {
  /* eslint-disable @typescript-eslint/naming-convention -- The namings use a provided value */
  1: colsSize.one,
  2: colsSize.two,
  3: colsSize.three,
  4: colsSize.four
  /* eslint-enable */
};

/**
 * Calculates the size of the columns based on the amount of items to be shown for XL screens.
 * The key is the amount of shown items.
 * The value is the size of the columns.
 */
const colsSizeXl = {
  /* eslint-disable @typescript-eslint/naming-convention -- The namings use a provided value */
  1: colsSize.one,
  2: colsSize.two,
  3: colsSize.three,
  4: colsSize.four,
  5: colsSize.six,
  6: colsSize.six
  /* eslint-enable */
};

/** Default gray vertical border to show in between items */
const DEFAULT_BORDER = CommonStyles.Borders.divider;

/** Default height in pixels of the info bar */
const DEFAULT_HEIGHT = 80;

/** Interface for the getItemsHeight function props*/

/** Single item (column) in the information bar. */

/** Action button configuration for the information bar. */

/**
 * Component that shows an information bar about the current page.
 */
export function PageInfoBar(t0) {
  const $ = _c(52);
  const {
    items: t1,
    action,
    isLoading,
    customItemsPerRow,
    barHeight
  } = t0;
  let T0;
  let T1;
  let T2;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== action || $[1] !== barHeight || $[2] !== customItemsPerRow || $[3] !== isLoading || $[4] !== t1) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const items = t1 === undefined ? [] : t1;
      const itemsPerRow = {
        ...defaultItemsPerRow,
        ...customItemsPerRow
      };
      const visibleItems = items.filter(_temp);
      const getRows = function getRows(itemsPerRow_0) {
        return Math.max(Math.ceil(visibleItems.length / itemsPerRow_0), 1);
      };
      let t10;
      if ($[16] !== action || $[17] !== barHeight || $[18] !== getRows) {
        t10 = function getItemsHeight(t11) {
          const {
            isActionsInSameRow,
            itemsPerRow: itemsPerRow_1,
            itemHeight,
            actionsHeight
          } = t11;
          const rows = getRows(itemsPerRow_1);
          const baseBarHeight = barHeight || DEFAULT_HEIGHT;
          const actualActionsHeight = !isActionsInSameRow && action && !action.isHidden ? actionsHeight : 0;
          return `${baseBarHeight + actualActionsHeight + (rows - 1) * itemHeight}px`;
        };
        $[16] = action;
        $[17] = barHeight;
        $[18] = getRows;
        $[19] = t10;
      } else {
        t10 = $[19];
      }
      const getItemsHeight = t10;
      let t11;
      if ($[20] !== getItemsHeight) {
        t11 = function getItemsHeightXs(itemsPerRow_2) {
          return getItemsHeight({
            itemsPerRow: itemsPerRow_2,
            isActionsInSameRow: false,
            itemHeight: 47,
            actionsHeight: 50
          });
        };
        $[20] = getItemsHeight;
        $[21] = t11;
      } else {
        t11 = $[21];
      }
      const getItemsHeightXs = t11;
      let t12;
      if ($[22] !== getItemsHeight) {
        t12 = function getItemsHeightSm(itemsPerRow_3) {
          return getItemsHeight({
            itemsPerRow: itemsPerRow_3,
            isActionsInSameRow: false,
            itemHeight: 40,
            actionsHeight: 50
          });
        };
        $[22] = getItemsHeight;
        $[23] = t12;
      } else {
        t12 = $[23];
      }
      const getItemsHeightSm = t12;
      let t13;
      if ($[24] !== getItemsHeight) {
        t13 = function getItemsHeightMd(itemsPerRow_4) {
          return getItemsHeight({
            itemsPerRow: itemsPerRow_4,
            isActionsInSameRow: false,
            itemHeight: 50,
            actionsHeight: 45
          });
        };
        $[24] = getItemsHeight;
        $[25] = t13;
      } else {
        t13 = $[25];
      }
      const getItemsHeightMd = t13;
      let t14;
      if ($[26] !== getItemsHeight) {
        t14 = function getItemsHeightLgAndXL(itemsPerRow_5) {
          return getItemsHeight({
            itemsPerRow: itemsPerRow_5,
            isActionsInSameRow: true,
            itemHeight: 50,
            actionsHeight: 0
          });
        };
        $[26] = getItemsHeight;
        $[27] = t14;
      } else {
        t14 = $[27];
      }
      const getItemsHeightLgAndXL = t14;
      let t15;
      if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = function shouldShowLeftBorder(index, itemsPerRow_6) {
          return index > 0 && !(index % itemsPerRow_6 === 0);
        };
        $[28] = t15;
      } else {
        t15 = $[28];
      }
      const shouldShowLeftBorder = t15;
      const isLastItem = function isLastItem(index_0) {
        return index_0 === visibleItems.length - 1;
      };
      if (isLoading) {
        let t16;
        if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
          t16 = <Skeleton variant="rectangular" height="80px" sx={{
            mt: "12px"
          }} />;
          $[29] = t16;
        } else {
          t16 = $[29];
        }
        t9 = t16;
        break bb0;
      }
      T2 = Grid;
      t7 = true;
      t8 = {
        py: 0,
        mt: "12px",
        backgroundColor: "surfaces.secondary",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: {
          xs: getItemsHeightXs(itemsPerRow.xs),
          sm: getItemsHeightSm(itemsPerRow.sm),
          md: getItemsHeightMd(itemsPerRow.md),
          lg: getItemsHeightLgAndXL(itemsPerRow.lg),
          xl: getItemsHeightLgAndXL(itemsPerRow.xl)
        }
      };
      T1 = Grid;
      if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
          py: 0,
          my: 0
        };
        $[30] = t5;
      } else {
        t5 = $[30];
      }
      const t16 = action && !action.isHidden ? colsSize.twoThird : colsSize.one;
      if ($[31] !== t16) {
        t6 = {
          xs: colsSize.one,
          lg: t16
        };
        $[31] = t16;
        $[32] = t6;
      } else {
        t6 = $[32];
      }
      T0 = Grid;
      t2 = true;
      if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
          py: 0,
          my: 0
        };
        $[33] = t3;
      } else {
        t3 = $[33];
      }
      t4 = visibleItems.map((item_0, index_1) => <Grid key={`infoBarItem-${index_1}`} sx={{
        px: "20px",
        pt: "5px",
        width: "500px",
        borderBottom: {
          xs: isLastItem(index_1) ? "none" : DEFAULT_BORDER,
          sm: "none"
        },
        borderLeft: {
          xs: "none",
          sm: shouldShowLeftBorder(index_1, itemsPerRow.sm) ? DEFAULT_BORDER : "none",
          md: shouldShowLeftBorder(index_1, itemsPerRow.md) ? DEFAULT_BORDER : "none",
          lg: shouldShowLeftBorder(index_1, itemsPerRow.lg) ? DEFAULT_BORDER : "none",
          xl: shouldShowLeftBorder(index_1, itemsPerRow.xl) ? DEFAULT_BORDER : "none"
        }
      }} size={{
        xs: colsSize.one,
        sm: colsSizeSm[item_0.columnSize ?? items.length] ?? colsSize.two,
        md: colsSizeMd[item_0.columnSize ?? items.length] ?? colsSize.six,
        lg: colsSizeLg[item_0.columnSize ?? items.length] ?? colsSize.six,
        xl: colsSizeXl[item_0.columnSize ?? items.length] ?? colsSize.six
      }}><Grid component="div">{item_0.content}</Grid></Grid>);
    }
    $[0] = action;
    $[1] = barHeight;
    $[2] = customItemsPerRow;
    $[3] = isLoading;
    $[4] = t1;
    $[5] = T0;
    $[6] = T1;
    $[7] = T2;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    T0 = $[5];
    T1 = $[6];
    T2 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  let t10;
  if ($[34] !== T0 || $[35] !== t2 || $[36] !== t3 || $[37] !== t4) {
    t10 = <T0 container={t2} sx={t3}>{t4}</T0>;
    $[34] = T0;
    $[35] = t2;
    $[36] = t3;
    $[37] = t4;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== T1 || $[40] !== t10 || $[41] !== t5 || $[42] !== t6) {
    t11 = <T1 sx={t5} size={t6}>{t10}</T1>;
    $[39] = T1;
    $[40] = t10;
    $[41] = t5;
    $[42] = t6;
    $[43] = t11;
  } else {
    t11 = $[43];
  }
  let t12;
  if ($[44] !== action) {
    t12 = action && !action.isHidden && <Grid sx={{
      py: 0,
      my: 0,
      mt: {
        xs: 0,
        sm: "10px"
      },
      mb: "10px",
      textAlign: {
        xs: "center",
        lg: "end"
      }
    }} size={{
      xs: colsSize.one,
      lg: colsSize.three
    }}><Grid sx={{
        px: "20px"
      }}>{action.content}</Grid></Grid>;
    $[44] = action;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] !== T2 || $[47] !== t11 || $[48] !== t12 || $[49] !== t7 || $[50] !== t8) {
    t13 = <T2 container={t7} sx={t8}>{t11}{t12}</T2>;
    $[46] = T2;
    $[47] = t11;
    $[48] = t12;
    $[49] = t7;
    $[50] = t8;
    $[51] = t13;
  } else {
    t13 = $[51];
  }
  return t13;
}
function _temp(item) {
  return !item.isHidden;
}